import MainContainer from "./MainContainer";
import Container from "./Container";
import ContainerFluid from "./ContainerFluid";
import Row from "./Row";
import Col from "./Col";

const Grid = { MainContainer, Container, ContainerFluid, Row, Col };

export default Grid;
